const UserActionTypes = {
    SIGN_IN_START: "SIGN_IN_START",
    SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
    SIGN_IN_FAILURE: "SIGN_IN_FAILURE",

    SIGN_UP_START: "SIGN_UP_START",
    SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
    SIGN_UP_FAILURE: "SIGN_UP_FAILURE",

    SIGN_OUT_START: "SIGN_OUT_START",
    SIGN_OUT_SUCCESS: "SIGN_OUT_SUCCESS",
    SIGN_OUT_FAILURE: "SIGN_OUT_FAILURE",

    CHECK_USER_SESSION: "CHECK_USER_SESSION",

    SET_POKEMON_START: "SET_POKEMON_START",
    SET_POKEMON_SUCCESS: "SET_POKEMON_SUCCESS",
    SET_POKEMON_FAILURE: "SET_POKEMON_FAILURE",

    REMOVE_POKEMON_START: "REMOVE_POKEMON_START",
    REMOVE_POKEMON_SUCCESS: "REMOVE_POKEMON_SUCCESS",
    REMOVE_POKEMON_FAILURE: "REMOVE_POKEMON_FAILURE"
}


export default UserActionTypes;